import { resolveComponent as n, resolveDirective as w, openBlock as r, createElementBlock as f, createVNode as i, withModifiers as _, withCtx as g, withDirectives as v, createBlock as h, Teleport as A, createElementVNode as k, createCommentVNode as M, renderSlot as I } from "vue";
import { _ as D } from "./_plugin-vue_export-helper-dad06003.js";
import { D as b } from "./DotsHorizontalIcon-41c0040b.js";
import { B as N } from "./ButtonTertiaryIconMd-3994fc64.js";
import { NavbarSidebar as y } from "./navbars.js";
import "./CardVideo-d193ca09.js";
import "./glightbox-13d8fc52.js";
import "./FormRichText.model-53e072ea.js";
import { D as B } from "./DropdownMenu-cf91b06e.js";
const C = {
  components: {
    ButtonTertiaryIconMd: N,
    DotsHorizontalIcon: b,
    NavbarSidebar: y,
    DropdownMenu: B
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      showActions: !1,
      vcoConfig: {
        handler: this.hide,
        capture: !0
      }
    };
  },
  methods: {
    hide() {
      this.showActions = !1;
    }
  }
}, z = { class: "relative" };
function H(c, t, e, S, o, p) {
  const d = n("DotsHorizontalIcon"), a = n("ButtonTertiaryIconMd"), m = n("DropdownMenu"), u = n("NavbarSidebar"), s = w("click-outside");
  return r(), f("div", z, [
    i(a, {
      onClick: t[0] || (t[0] = _((l) => o.showActions = !o.showActions, ["stop"]))
    }, {
      default: g(() => [
        i(d)
      ]),
      _: 1
    }),
    v(i(m, {
      open: o.showActions,
      "onUpdate:open": t[1] || (t[1] = (l) => o.showActions = l),
      right: "",
      items: e.actions
    }, null, 8, ["open", "items"]), [
      [s, o.vcoConfig]
    ]),
    (r(), h(A, { to: "body" }, [
      i(u, {
        open: o.showActions,
        "onUpdate:open": t[2] || (t[2] = (l) => o.showActions = l),
        header: e.title,
        items: e.actions
      }, null, 8, ["open", "header", "items"])
    ]))
  ]);
}
const L = /* @__PURE__ */ D(C, [["render", H]]), x = {
  components: {
    DotsHorizontalIcon: b,
    NavbarSidebar: y,
    DropdownMenu: B
  },
  props: {
    actions: {
      type: Array,
      default: () => []
    },
    title: {
      type: String,
      default: ""
    }
  },
  emits: ["open", "close"],
  data() {
    return {
      showActions: !1
    };
  },
  computed: {
    hasButtonSlot() {
      return !!this.$slots.button;
    }
  },
  watch: {
    showActions(c) {
      c ? this.$emit("open") : this.$emit("close");
    }
  },
  methods: {
    hide() {
      this.showActions = !1;
    }
  }
}, T = { class: "relative" };
function U(c, t, e, S, o, p) {
  const d = n("DotsHorizontalIcon"), a = n("DropdownMenu"), m = n("NavbarSidebar"), u = w("click-outside");
  return r(), f("div", T, [
    k("div", {
      onClick: t[0] || (t[0] = _((s) => o.showActions = !o.showActions, ["stop"]))
    }, [
      p.hasButtonSlot ? M("", !0) : (r(), h(d, {
        key: 0,
        class: "h-5 w-5 ct-fg-2 hover:ct-fg-2"
      })),
      I(c.$slots, "button")
    ]),
    v(i(a, {
      open: o.showActions,
      "onUpdate:open": t[1] || (t[1] = (s) => o.showActions = s),
      right: "",
      items: e.actions
    }, null, 8, ["open", "items"]), [
      [u, p.hide]
    ]),
    (r(), h(A, { to: "body" }, [
      i(m, {
        open: o.showActions,
        "onUpdate:open": t[2] || (t[2] = (s) => o.showActions = s),
        header: e.title,
        items: e.actions
      }, null, 8, ["open", "header", "items"])
    ]))
  ]);
}
const O = /* @__PURE__ */ D(x, [["render", U]]);
export {
  L as P,
  O as a
};
